export default __webpack_public_path__ + "static/media/rhapsody-badge.0d06fde1.png";